import { CERTS, COURSES, type Certificate, type Course } from './courses';

/** Chu vi vòng tiến độ r=18 (viewBox 48) */
export const RING_LEN = 2 * Math.PI * 18;

/** Chuỗi `stroke-dasharray` của vòng tiến độ, p kẹp 0–1. */
export function ring(p: number): string {
  return `${(Math.max(0, Math.min(1, p)) * RING_LEN).toFixed(1)} ${RING_LEN.toFixed(1)}`;
}

export function progress(c: Course): number {
  return c.total ? c.done / c.total : 0;
}

export function pctLabel(c: Course): string {
  return `${Math.round(progress(c) * 100)}%`;
}

export type CourseCta = 'Xem chứng chỉ' | 'Làm bài kiểm tra' | 'Học tiếp' | 'Bắt đầu';

export function ctaOf(c: Course): CourseCta {
  if (c.passed) return 'Xem chứng chỉ';
  if (c.done === c.total) return 'Làm bài kiểm tra';
  return c.done ? 'Học tiếp' : 'Bắt đầu';
}

/** Khoá đang học = chưa đạt. */
export function learning(courses: readonly Course[] = COURSES): Course[] {
  return courses.filter((c) => !c.passed);
}

/** Bắt buộc có hạn, chưa đạt, gần hạn trước (quá hạn lên đầu). */
export function dueSoon(courses: readonly Course[] = COURSES): Course[] {
  return courses.filter((c) => c.required && !c.passed && c.dd !== null).sort((a, b) => a.dd! - b.dd!);
}

export type DueTone = 'err' | 'warn' | 'neutral';

/** Màu ô ngày: đỏ quá hạn, vàng ≤ 3 ngày làm việc. */
export function dueTone(dd: number): DueTone {
  return dd < 0 ? 'err' : dd <= 3 ? 'warn' : 'neutral';
}

export function mySoonCerts(owner: string, certs: readonly Certificate[] = CERTS): Certificate[] {
  return certs.filter((c) => c.owner === owner && c.status !== 'ok');
}

/** Số khoá bắt buộc chưa đạt (ô KPI "Bắt buộc đang mở"). */
export function openRequired(courses: readonly Course[] = COURSES): number {
  return courses.filter((c) => c.required && !c.passed).length;
}

export function overdueCount(courses: readonly Course[] = COURSES): number {
  return courses.filter((c) => c.required && !c.passed && c.late).length;
}

export type ExamState = 'pass' | 'ready' | 'retry' | 'lock';
export const PASS_SCORE = 80;

/** Trạng thái bài kiểm tra của khoá: đạt · sẵn sàng · làm lại (đã thi chưa đạt) · chưa mở (học chưa xong). */
export function examState(c: Course): ExamState {
  if (c.passed) return 'pass';
  if (c.done < c.total) return 'lock';
  return c.tries.length ? 'retry' : 'ready';
}

export function bestTry(c: Course): number {
  return c.tries.length ? Math.max(...c.tries) : 0;
}

export function matches(c: Course, q: string): boolean {
  return !q.trim() || c.k.toLowerCase().includes(q.trim().toLowerCase());
}
